import { render, staticRenderFns } from "./modalCrearPromocion.vue?vue&type=template&id=2c0a593f&scoped=true"
import script from "./modalCrearPromocion.vue?vue&type=script&lang=js"
export * from "./modalCrearPromocion.vue?vue&type=script&lang=js"
import style0 from "./modalCrearPromocion.vue?vue&type=style&index=0&id=2c0a593f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a593f",
  null
  
)

export default component.exports